<template>
  <div class="page">
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="4">
            <el-form-item>
              <el-input
                style="width: 150px; margin-right: 10px"
                placeholder="请输入关键字"
                v-model="search.keyword"
                @keyup.enter.native="clickSearch"
                clearable
              ></el-input>
              <el-button
                @click="clickSearch"
                icon="el-icon-search"
                type="warning"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="门店">
              <el-select
                style="width: 120px"
                v-model="search.shopId"
                @change="changeSearch"
              >
                <el-option
                  v-for="item in shopsList"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="合同状态">
              <el-select
                v-model="search.isSendContract"
                style="width: 100px"
                @change="changeSearch"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: -1 },
                    { label: '未发送', value: 0 },
                    { label: '已发送', value: 1 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="支付状态">
              <el-select
                style="width: 100px"
                v-model="search.isPay"
                @change="changeSearch"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: -1 },
                    { label: '未支付', value: 0 },
                    { label: '已支付', value: 1 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="洗美状态">
              <el-select
                style="width: 100px"
                v-model="search.status"
                @change="changeSearch"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: 0 },
                    { label: '已完成', value: 1 },
                    { label: '进行中', value: 2 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="创建时间">
              <el-date-picker
                @change="changeSearch"
                style="width: 240px"
                v-model="datetimerange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <resetBtn @reset="reset"></resetBtn>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="pageConBox">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="门店" prop="shopId" min-width="50">
          <template slot-scope="props">
            <span>{{ $public.getShopNameById(props.row.shopId) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="洗美订单" prop="washRecordId" min-width="120">
        </el-table-column>
        <el-table-column label="顾客信息" min-width="120">
          <template slot-scope="props">
            <div
              style="cursor: pointer"
              @click="
                $router.push({
                  path: '/huiyuan/huiyuanSee',
                  query: { id: props.row.memberId },
                })
              "
            >
              {{ props.row.memberName }}
              <div style="color: #409eff">({{ props.row.memberMobile }})</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="洗美宠物/品种/性别" min-width="80">
          <template slot-scope="props">
            <div>
              {{ props.row.petName }}
              <div>{{ props.row.typeName }}/{{ props.row.sex }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="服务项目" min-width="150">
          <template slot-scope="props">
            <div v-for="item in props.row.goodsNames" :key="item">
              {{ item }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" prop="isPay ">
          <template slot-scope="props">
            <div>{{ props.row.isPay ? "已支付" : "未支付" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="洗美状态" prop="status ">
          <template slot-scope="props">
            <div>
              <span v-if="props.row.status == 1" style="color: green">
                已完成
              </span>
              <span v-if="props.row.status == 2" style="color: red">
                进行中</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合同状态">
          <template slot-scope="props">
            <div>
              <span v-if="props.row.needContract == 0"> 不需要发送 </span>
              <span
                v-if="props.row.needContract == 1 && !props.row.contractNum"
              >
                待发送
              </span>
              <span v-if="props.row.needContract == 1 && props.row.contractNum">
                已发送
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合同编号" prop="contractNum" min-width="120">
        </el-table-column>
        <el-table-column label="创建人" prop="createUserName">
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="props">
            <div>
              {{ $public.FTime(props.row.createTime, "YYYY-MM-DD HH:mm") }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <page
        style="padding: 10px 0"
        :page="page.page"
        :total="page.total"
        @change="changePage"
      ></page>
    </div>
  </div>
</template>
<script>
import page from "../../../components/page.vue";
import resetBtn from "../../../components/resetBtn.vue";
import shopsList from "../../../util/shopsList.js";
export default {
  components: { page, resetBtn },
  data() {
    return {
      search: {
        shopId: "",
        status: 0,
        isPay: -1,
        startTime: "",
        endTime: "",
        isNeedContract: -1,
        isSendContract: -1,
        pageIndex: 0,
        pageSize: 0,
        keyword: "",
      },
      shopsList: shopsList,
      datetimerange: [],
      tableData: [],

      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    reset() {
      this.search = {
        shopId: "",
        status: 0,
        isPay: -1,
        isNeedContract: -1,
        isSendContract: -1,
        keyword: "",
      };
      this.datetimerange = [];
      this.page.page = 1;
      this.getTableData();
    },

    clickSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },

    // 改变分页
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    getTableData() {
      let params = {
        shopId: this.search.shopId,
        status: this.search.status,
        isPay: this.search.isPay,
        isNeedContract: this.search.isNeedContract,
        isSendContract: this.search.isSendContract,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.search.keyword,
      };
      if (this.datetimerange && this.datetimerange.length == 2) {
        params.startTime = (
          "" + new Date(this.datetimerange[0]).getTime()
        ).substr(0, 10);
        params.endTime = (
          "" + new Date(this.datetimerange[1]).getTime()
        ).substr(0, 10);
      }
      let loading = this.$loading();
      this.$http.post("/api/WashBeauty/PetList", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          console.log(res, "res");
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  .searchBox {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .pageConBox {
    min-height: 600px;
  }
}
</style>
